// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__8evh7","h2":"Heading_h2__rNLtP","h3":"Heading_h3__U-efn","h4":"Heading_h4__E1YEm","h5":"Heading_h5__HG3Bc","h6":"Heading_h6__RqKlc"};